
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"20 9 36 36","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.607 32.853h-3.144v2.256h-2.461v-2.256H32v-1.982h2.002v-1.045H32v-1.982h2.002V20.89h5.44c1.568 0 2.822.41 3.76 1.23.937.814 1.405 1.898 1.405 3.252 0 1.38-.446 2.464-1.337 3.252-.892.781-2.133 1.182-3.721 1.201h-3.086v1.045h3.144v1.982zm-3.144-5.01h2.94c.885 0 1.562-.204 2.03-.614.47-.41.704-1.023.704-1.836 0-.73-.231-1.325-.694-1.788-.455-.462-1.087-.703-1.894-.722h-3.086v4.96z"}})])
          )
        }
      }
    